"use client";

import React, { useEffect } from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";

export interface NetworkDialogProps extends SDialogProps {
    onRefresh?: (s?:any) => void;
}

export const NetworkDialogFC: React.FC<NetworkDialogProps> = (props) => {
    const { fcKey, isOpen, onClose,onRefresh } = props;
    useEffect(() => {
        console.log("NetworkDialog initialized");

        return () => {
            console.log("NetworkDialog disposed");
        };
    }, []);

    if (!isOpen) return null;

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            title={
                <>
                    <img
                        width="339"
                        height="344"
                        src="/img/network_disconnect.webp"
                        alt=""
                        style={{ width: "3.39rem", height: "3.34rem" }}
                    />
                </>
            }
            buttons={[
                {
                    label: "Refresh",
                    onClick: () => {
                        onClose?.();
                        onRefresh?.();
                    },
                    style: "greenBtn",
                },
            ]}
        >
            <p>Some thing wrong with your connection, please make sure your internet is turned on.</p>
        </SDialogFC>
    );
};
